import {
  base_colorRaisedSurface,
  base_colorSurfaceMutedHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_xs } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const chartFrame = css`
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
`

export const svg = css`
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
`

export const barSegment = css`
  cursor: pointer;
  transition:
    opacity 120ms ease,
    filter 120ms ease;

  &:focus-visible {
    outline: none;
    filter: drop-shadow(0 0 0.25rem ${text_colorTextPrimary});
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const tooltip = css`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  min-width: 236px;
  padding: ${spacing(2)};
  border-radius: ${cornerRadius};
  background: ${base_colorSurfaceMutedHover};
  /* DS gap: tooltip elevation is specified by the dashboard reference, but no
   * named DS shadow token exists for this surface yet. */
  box-shadow: 0 8px 28px rgba(30, 44, 76, 0.15);
  color: ${text_colorTextPrimary};
  pointer-events: none;
  transform: translate3d(var(--tooltip-x, 0), var(--tooltip-y, 0), 0);
  transition:
    transform 80ms ease-out,
    opacity 100ms ease;
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const tooltipTitle = css`
  ${font_xs};
  margin: 0;
  padding: ${spacing(1)} ${spacing(3)} ${spacing(2)};
  color: ${text_colorTextSecondary};
  font-weight: 500;
`

export const tooltipTable = css`
  ${font_xs};
  display: flex;
  flex-direction: column;
  color: ${text_colorTextSecondary};
`

export const tooltipSegmentRow = (isActive: boolean) => css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  padding: ${spacing(2)} ${spacing(3)};
  border-radius: ${spacing(1)};
  background: ${isActive ? base_colorRaisedSurface : 'transparent'};
  color: ${isActive ? text_colorTextPrimary : text_colorTextSecondary};
  font-weight: ${isActive ? 500 : 400};
  line-height: 16px;
  transition: background 100ms ease;
`

export const tooltipSeriesCell = css`
  display: flex;
  flex: 1;
  align-items: center;
  gap: ${spacing(2)};
  min-width: 0;
`

export const tooltipSwatch = css`
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  border-radius: 50%;
`

export const tooltipValue = css`
  color: ${text_colorTextPrimary};
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
`

export const legend = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing(1)} ${spacing(2)};
  margin-top: ${spacing(1)};
  padding: 0;
  list-style: none;
`

export const legendItem = css`
  ${font_xs};
  display: flex;
  align-items: center;
  gap: ${spacing(0.75)};
  color: ${text_colorTextSecondary};
`

export const legendSwatch = css`
  width: 10px;
  height: 10px;
  flex: 0 0 10px;
  border-radius: 2px;
`
